import { Box, Paper, Stack, Typography } from '@mui/material';
import IncSwitchBase from 'components/forms/fields/inc-switch-field/inc-switch-base/inc-switch-base.component';
import { useMemo } from 'react';
import { blue, green } from '@mui/material/colors';
import { useTranslation } from 'react-i18next';
import StandardHoursListItem from './standard-hours-list-item/standard-hours-list-item.component';
import { getGroupedBackgroundEvents } from 'components/location-hours/temporary-hours-calendar/temporary-hours.utils';
import { useKitchenCapacityContext } from 'components/kitchen-capacity/kitchen-capacity.context';

const StandardHoursList = () => {
  const { t } = useTranslation();
  const {
    preparationTime: {
      backgroundEvents,
      standardHours: { isShowingNormalHours, setIsShowingNormalHours },
    },
  } = useKitchenCapacityContext();

  const onChange = (_e, checked) => {
    setIsShowingNormalHours(checked);
  };

  const groupedBackgroundEvents = useMemo(
    () => getGroupedBackgroundEvents(backgroundEvents),
    [backgroundEvents],
  );

  const isBgEventsEmpty = array => array.length === 0;

  return (
    <Paper
      elevation={3}
      sx={{ p: 2 }}
      data-testid="PreparationTime.StandardHours"
    >
      <Typography variant="h5">
        {t('KitchenCapacity.preparationTime.standardHours.title')}
      </Typography>
      <IncSwitchBase
        label={t(
          'KitchenCapacity.preparationTime.standardHours.showHoursSwitch.label',
        )}
        value={isShowingNormalHours}
        onChange={onChange}
        FormControlProps={{ sx: { mt: 1 } }}
        data-testid="ShowHours"
        disabled={isBgEventsEmpty(groupedBackgroundEvents)}
      />

      <Stack
        display="flex"
        direction="column"
        gap={2}
        maxWidth={320}
        data-testid="StandardHours.List"
      >
        {isBgEventsEmpty(groupedBackgroundEvents) ? (
          <Typography
            variant="body2"
            color="text.secondary"
            data-testid="BgEvents.Empty.Label"
          >
            {t('KitchenCapacity.preparationTime.standardHours.emptyLabel')}
          </Typography>
        ) : (
          groupedBackgroundEvents.map(event => (
            <Box key={event.day}>
              <Typography key={event.day} variant="body1">
                {event.day}:
              </Typography>
              {event.pickup && event.pickup.length > 0 && (
                <StandardHoursListItem
                  orderTypeWithTimeSlots={t(
                    'KitchenCapacity.preparationTime.standardHours.orderTypeOptions.pickup',
                    {
                      timeSlots: event.pickup.join(', '),
                    },
                  )}
                  color={blue[500]}
                />
              )}
              {event.delivery && event.delivery.length > 0 && (
                <StandardHoursListItem
                  orderTypeWithTimeSlots={t(
                    'KitchenCapacity.preparationTime.standardHours.orderTypeOptions.delivery',
                    {
                      timeSlots: event.delivery.join(', '),
                    },
                  )}
                  color={green[500]}
                />
              )}
            </Box>
          ))
        )}
      </Stack>
    </Paper>
  );
};

export default StandardHoursList;
